import { Shimmer } from "@fluentui/react";
import openAI from "../../assets/openai.svg";
import { customerInfoStyles as styles } from "./CustomerInfo.styles";

export default function CustomerInfo(props) {
  return (
    <div className={styles.container}>
      {!props.loaded ? (
        <div>
          <Shimmer className={styles.shimmer35} shimmerColors={{ shimmer: "rgb(222, 236, 249)" }} />
          <Shimmer className={styles.shimmer} shimmerColors={{ shimmer: "rgb(222, 236, 249)" }} />
          <Shimmer className={styles.shimmer} shimmerColors={{ shimmer: "rgb(222, 236, 249)" }} />
          <Shimmer className={styles.shimmer90} shimmerColors={{ shimmer: "rgb(222, 236, 249)" }} />
          <Shimmer className={styles.shimmer} shimmerColors={{ shimmer: "rgb(222, 236, 249)" }} />
          <Shimmer className={styles.shimmer95} shimmerColors={{ shimmer: "rgb(222, 236, 249)" }} />
        </div>
      ) : (
        <div>
          <h4 className={styles.header}>
            <img src={openAI} width={20} height={20} alt="OpenAI logo" />
            <span className={styles.poweredBy}>Powered by Azure OpenAI</span>
          </h4>
          <div className={styles.description}>{props.displayext}</div>
        </div>
      )}
    </div>
  );
}
